import { Action, createReducer, State, on  } from '@ngrx/store';
import * as actions from './list-luminaries.actions';
import { SessionStore } from '@ildes/stores/session.store';

const initState = (state) => {
  const userId = SessionStore.getInstance()?.get()?.user?.id;
  const luminaries = localStorage.getItem(`${userId}.luminaries`);
  
  if (luminaries) {
    return JSON.parse(luminaries)?.value || [];
  } else {
    return [];
  }
}

const load = (state) => {
  return [...initState(state)];
 }

const create = (state, action) => {
  return [...state, {...action.luminary, _id: parseInt(`${Math.random()*1000000}`)}];
 }

 const remove = (state, action) => {
  return state.filter(({_id}) => _id !== action._id)
 }

 // TODO: modificar updatedAt
const update = (state, action) => {
  return state.map((luminary) => {
    if (luminary._id === action.id) {
      return {
        ...luminary,
        ...action.changes,
        updatedAt: new Date().toISOString()
      }
    }

    return luminary;
  });
}

const initialState = [];
const luminaries = createReducer(
  initialState,
  on(actions.initState, initState),
  on(actions.create, create),
  on(actions.update, update),
  on(actions.remove, remove),
  on(actions.loadLuminaries, load),
);

export function reducer(state: any[] | undefined, action: Action) {
  return luminaries(state, action);
}
